import IRealEstateSearchBean, {
    searchBeanMap,
    searchBeanMapAgencyFilter
} from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import {CONTRACT} from "@customTypes/ContractEnum";

// eslint-disable-next-line max-len
export function buildURL(
    cityURL: string,
    listingTypology: string,
    contractType: number | undefined | null,
    zone?: string | null,
    seoFilter?: string | null,
    agencyAndPlace?: string,
    district?: string | null
): string {

    let URL = "/";

    if (contractType) {
        URL += (contractType == CONTRACT.AUCTION ?
            // @ts-ignore
            window["_auctionLabel"] : contractType == CONTRACT.RENT ? window["_rentLabel"] : window["_saleLabel"]) + "-";
    }

    URL += `${listingTypology}/`;

    if (agencyAndPlace)
        URL += `${agencyAndPlace}/`;

    if (cityURL)
        URL += `${cityURL.replace(/^-+|-+$/g, "")}/`;

    if (zone) {
        URL += `${zone.replace(/^_+|_+$/g, "")}/`;
    }

    if (!zone && district) {
        URL += `${district.replace(/^_+|_+$/g, "")}/`;
    }

    if (seoFilter) {
        URL += `${seoFilter.replace(/^_+|_+$/g, "")}/`;
    }
    return URL;
}

export function buildParams(searchBean: IRealEstateSearchBean): string {
    const params = Object.keys(searchBeanMap).map(key => {
        if (searchBean[key]) {
            return encodeURIComponent(searchBeanMap[key]) + "=" +
                encodeURIComponent(searchBean[key]);
        } else return null
    }).filter(param => param !== null);

    return params.length ? `?${params.join("&")}` : "";
}

export function buildParamsForAgency(searchBean: IRealEstateSearchBean): string {
    const params = Object.keys(searchBeanMapAgencyFilter).map(key => {
        if (searchBean[key]) {
            if (Array.isArray(searchBean[key])) {
                const arr = searchBean[key];
                const nameField = searchBeanMapAgencyFilter[key];
                let strToReturn = "";
                for (let i = 0; i < arr.length; i++) {
                    strToReturn += encodeURIComponent(nameField) + "=" +
                        encodeURIComponent(arr[i]);
                    strToReturn += (i < arr.length - 1) ? "&" : "";
                }
                return strToReturn;
            } else {
                return encodeURIComponent(searchBeanMapAgencyFilter[key]) + "=" +
                    encodeURIComponent(searchBean[key]);
            }

        } else return null
    }).filter(param => param !== null);

    return params.length ? `?${params.join("&")}` : "";
}